import { render } from "./marketing.vue?vue&type=template&id=e79b4810"
import script from "./marketing.vue?vue&type=script&lang=js"
export * from "./marketing.vue?vue&type=script&lang=js"

import "./marketing.vue?vue&type=style&index=0&id=e79b4810&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__